import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AuthorsCollab, CareTeam } from '../../assets/components/svgs';
import Card from '../shared/cards/Card';
import { setCareTeamsList } from '../../app/carePlanReducer';
import PickList, { PICKLIST_TYPES } from '../shared/Fields/PickList';
import { AppConstants } from '../../constants/AppConstants';
import { formatContributerPills, getCareTeamsList, removeContributorPill } from './carePlanUtils';
import Pills from './Reusable/Pills';
import { cloneDeep, findIndex } from 'lodash';
import styled from 'styled-components/macro';
import DependentSelector from './DependentSelector';
import { ChildFormProps } from './CarePlanTemplate';
import { PlusCircleIcon } from '@heroicons/react/solid';
import PillsButton from '../shared/Fields/PillsButton';

export const ErrorLabel = styled.span`
  fontsize: 11px;
  color: red;
`;

const Collaborators = ({
  isEdit,
  formData,
  formError,
  setFormData,
  setFormError
}: ChildFormProps) => {
  const params = useParams();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  // const careTeamList: any = useAppSelector((state) => state.carePlanData.careTeamList) || [];
  const careplanConfig: any = useAppSelector((state) => state.carePlanData.careplanConfig) || {};

  const updateFormData = (value: any) => {
    setFormData(value);
  };

  // useEffect(() => {
  //   async function init() {
  //     const data = await getCareTeamsList();
  //     if (data.length) {
  //       dispatch(setCareTeamsList(data));
  //     }
  //   }
  //   if (!careTeamList.length) {
  //     init();
  //   }
  // }, [careTeamList]);

  const removeCondition = (itemKey: string, itemValue: string) => {
    let clonedData = cloneDeep(formData?.careTeam);
    const index = findIndex(clonedData, function (item: any) {
      return item?.[itemKey] === itemValue;
    });

    if (index !== -1) {
      clonedData.splice(index, 1);
      updateFormData({ careTeam: clonedData });
    }
  };

  return (
    // <div className="h-[75vh] overflow-hidden p-4">
    <div className="mt-4">
      <Card
        title={t('T_CARE_PLAN_AUTHORS')}
        icon={AuthorsCollab}
        alt={t('T_CARD_ALT_MESSAGE')}
        height=""
        width=""
      >
        <DependentSelector
          formData={formData}
          setFormData={(value: any) => {
            setFormData(value);
          }}
          setFormError={setFormError}
          disabled={!isEdit}
          primaryFieldKey="authorCategory"
          primaryFieldLabel={t('T_CARE_PLAN_AUTHOR_CATEGORY')}
          secondaryFieldKey="author"
          secondaryFieldLabel={t('T_CARE_PLAN_AUTHOR')}
          formError={formError}
          primaryFieldOptions={careplanConfig?.[AppConstants.CAREPLAN_CONFIG_TEMPLATE_AUTHOR_TYPES]}
        ></DependentSelector>

        <DependentSelector
          formData={formData}
          setFormData={(value: any) => {
            setFormData(value);
          }}
          disabled={!isEdit}
          primaryFieldKey="contributorCategory"
          primaryFieldLabel={t('T_CARE_PLAN_CONTRIBUTOR_CATEGORY')}
          secondaryFieldKey="contributor"
          secondaryFieldLabel={t('T_CARE_PLAN_CONTRIBUTOR')}
          formError={formError}
          setFormError={setFormError}
          multiSupport
          multiFieldKey="contributor"
          primaryFieldOptions={
            careplanConfig?.[AppConstants.CAREPLAN_CONFIG_TEMPLATE_CONTRIBUTOR_TYPES]
          }
        ></DependentSelector>
        {formData?.contributor?.length ? (
          <PillsButton
            pillId={'fieldgroup-pill'}
            pillMaxWidth={'100%'}
            disabled={!isEdit}
            rows={3}
            pillsData={formData?.contributor}
            removeFilter={(item: any) => {
              setFormData({ contributor: removeContributorPill(formData.contributor, item) });
            }}
          ></PillsButton>
        ) : (
          ''
        )}
      </Card>
      {/* <Card
        title={t('T_CARE_PLAN_CARE_TEAM')}
        icon={CareTeam}
        alt={t('T_CARD_ALT_MESSAGE')}
        height=""
        width=""
      >
        <div className="flex w-full flex-wrap">
          <div className="mb-5 flex w-full flex-col">
            <PickList
              fieldKey={'id'}
              fieldValues={['name']}
              label={t('T_CARE_PLAN_CARE_TEAM')}
              selectedItems={formData.careTeam}
              onSelectedChange={(items: any) => {
                updateFormData({ careTeam: items });
              }}
              items={careTeamList}
              disabled={!isEdit}
              readOnly={false}
              type={PICKLIST_TYPES.MULTI}
            />
          </div>
          {formData?.careTeam?.length ? (
            <div>
              <div className="mb-2.5 text-base font-normal leading-6">
                {t('T_CARE_TEAM_SELECTED')}
              </div>
              <div className="mb-5 flex max-h-[20rem] w-full flex-wrap gap-2.5 overflow-y-auto">
                {formData?.careTeam?.map((item: any, index: number) => {
                  return (
                    <Pills
                      isLast={index === formData?.careTeam.length - 1}
                      key={index}
                      name={item?.name}
                      onClick={() => {
                        removeCondition('id', item?.id);
                      }}
                      removeAll={() => {
                        updateFormData({ careTeam: [] });
                      }}
                      disabled={!isEdit}
                    ></Pills>
                  );
                })}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </Card> */}
    </div>
  );
};

export default Collaborators;
